import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import { formatUnixTimestamp } from "@/react/datetime";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      { ...getColumnDef(schema.fields.id, "Audit ID"), type: TYPES.ID },
      {
        ...getColumnDef(schema.fields.displayName, "Display Name"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.auditTimestamp, "Audit Timestamp"),
        customCell: ({ getValue }) => (
          <strong>{formatUnixTimestamp(getValue())}</strong>
        ),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.eventType, "Event Type"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.objectType, "Object Type"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.objectKey, "Object Key"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.auditUser, "Audit User"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.impersonator, "Impersonator"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.correlationType, "Correlation Type"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.correlationId, "Correlation ID"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.details, "Details"),
        type: TYPES.STRING,
        defaultHidden: true,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
